import React, { useState } from 'react';
import { theme, st } from '../constants.js';

export const FI = ({ label, value, onChange, placeholder, type = 'text', required, readOnly, highlight }) => {
  const [focused, setFocused] = useState(false);
  const focusStyle = focused ? { borderColor: theme.primary, backgroundColor: '#fff', boxShadow: '0 0 0 3px rgba(79,70,229,0.1)' } : {};
  const hlStyle = highlight ? { backgroundColor: '#fffbeb', borderColor: '#fcd34d' } : {};
  return (
    <div style={st.ig}>
      <label style={st.label}>{label}{required && <span style={{ color: theme.danger }}> *</span>}</label>
      {type === 'textarea'
        ? <textarea style={{ ...st.input, ...st.textarea, ...focusStyle, ...hlStyle }} value={value || ''} onChange={onChange} placeholder={placeholder} readOnly={readOnly} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />
        : <input type={type} style={{ ...st.input, ...focusStyle, ...hlStyle, ...(readOnly ? { background: '#f0fdf4', color: theme.success, fontWeight: '800' } : {}) }} value={value || ''} onChange={onChange} placeholder={placeholder} required={required} readOnly={readOnly} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} />
      }
    </div>
  );
};

export const FS = ({ label, value, onChange, options, placeholder = 'Select' }) => (
  <div style={st.ig}>
    <label style={st.label}>{label}</label>
    <select style={st.input} value={value || ''} onChange={onChange}>
      <option value="">{placeholder}</option>
      {options.map(o => typeof o === 'string'
        ? <option key={o} value={o}>{o}</option>
        : <option key={o.v} value={o.v}>{o.l}</option>)}
    </select>
  </div>
);

export const Chips = ({ label, value = [], onChange, options, dangerOpts = [], warnOpts = [] }) => (
  <div style={st.ig}>
    {label && <label style={st.label}>{label}</label>}
    <div style={st.chipRow}>
      {options.map(o => {
        const on = value.includes(o);
        const style = on ? (dangerOpts.includes(o) ? st.chipDanger : warnOpts.includes(o) ? st.chipWarn : st.chipOn) : {};
        return <button key={o} type="button" style={{ ...st.chip, ...style }} onClick={() => onChange(on ? value.filter(x => x !== o) : [...value, o])}>{o}</button>;
      })}
    </div>
  </div>
);

export const SingleChip = ({ label, value, onChange, options }) => (
  <div style={st.ig}>
    {label && <label style={st.label}>{label}</label>}
    <div style={st.chipRow}>
      {options.map(o => <button key={o} type="button" style={{ ...st.chip, ...(value === o ? st.chipOn : {}) }} onClick={() => onChange(value === o ? '' : o)}>{o}</button>)}
    </div>
  </div>
);
